module.exports = function getResource(label, vars = []) {
    let resources = {
        next2Weeks: '2 prochaines semaines',
        orChooseDate: 'Ou choisir une date',
        filterByDate: 'Filtrer par date'
    };
    return resources[label];
};
